import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { IPackageCard } from '../../../Pages/PackageManagement/IPacakageManagement';

interface IUpdate extends IReduxState<IPackageCard> {
  updateableDate?: IPackageCard;
}

export const UpdatePackageSlicer = createSlice({
  name: 'UpdatePackage',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updatePackage: (state, _) => {
      state.isLoading = true;
    },
    successUpdatePackage: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdatePackage: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    PackageUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdatePackageState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updatePackage,
  failureUpdatePackage,
  successUpdatePackage,
  PackageUpdateableData,
  clearUpdatePackageState,
  clearUpdateableData,
} = UpdatePackageSlicer.actions;

export default UpdatePackageSlicer.reducer;
